import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbCookiesConsentPageComponent } from './kb-cookies-consent-page/kb-cookies-consent-page.component';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, ConfigModule, CmsConfig } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, AppRoutingModule, MediaModule } from '@spartacus/storefront';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
  declarations: [
    KbCookiesConsentPageComponent
  ],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    UrlModule,
    RouterModule,
    AppRoutingModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CookiesFlexComponent: {
          component: KbCookiesConsentPageComponent,
          guards: [SecureGuard]
        }
      }
    } as CmsConfig)
  ],
})
export class KbCookiesModule { }
